import request from '@/service/request'

/* 登录 */
const login = (params) => {
  return request.post('/auth/index/login', params)
}

/* 获取用户个人信息 */
const getUserInfo = (params) => {
  return request.post('/auth/index/getUserInfo')
}

/* 获取树菜单 */
const getMenu = () => {
  return request.post('/auth/info/listTree')
}

export {
  login,
  getUserInfo,
  getMenu
}
